import { formatAuthorizationHeader } from 'graphql/utils'
import {
  getAllAuthorizations,
  getUserAuthorization,
} from 'graphql/multisession'
import { isEqual, isObject } from 'lodash'
import ApolloClient from 'apollo-client'
import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import { errorPreventiveCacheRead } from 'utils'
import { GetInitialUserDocument, GetInitialUserQuery } from '@sketch/gql-types'

const normalizeHeaders = (headers: RequestInit['headers']) => {
  if (Array.isArray(headers)) {
    return Object.fromEntries(headers)
  } else if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries())
  } else if (isObject(headers)) {
    return { ...headers }
  } else {
    return {}
  }
}

const checkMultipleAuthorizationsFF = (
  client: ApolloClient<NormalizedCacheObject>
) => {
  const userData = errorPreventiveCacheRead<GetInitialUserQuery>(client, {
    query: GetInitialUserDocument,
  })

  return userData?.me.featureFlags?.includes('multiple-authorizations')
}

export const addCredentialsToOptions = (
  client: ApolloClient<NormalizedCacheObject>,
  sendSecondaryAuthorizations: boolean,
  options?: RequestInit,
  credentials = getUserAuthorization(client.cache)
) => {
  const allAuthorizations = getAllAuthorizations()
  const authorization = formatAuthorizationHeader(credentials)

  const headers = normalizeHeaders(options?.headers)
  const hasMultipleAuthorizationsFF = checkMultipleAuthorizationsFF(client)

  if (hasMultipleAuthorizationsFF && sendSecondaryAuthorizations) {
    const secondaryAuthorizations = allAuthorizations.filter(
      ({ fragment }) => !isEqual(fragment, credentials)
    )

    if (secondaryAuthorizations.length > 0) {
      headers['X-Auth-Token-Count'] = `${secondaryAuthorizations.length}`
      secondaryAuthorizations.forEach(({ fragment }, index) => {
        headers[`X-Auth-Token-${index + 1}`] = formatAuthorizationHeader(
          fragment
        )!
      })
    }
  }

  if (authorization) {
    headers['authorization'] = authorization
  }

  return {
    ...options,
    headers,
  }
}
